/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import '../assets/css/style.css'
import titleToushin from '../assets/img/title/title_toushin.svg'
import image1 from '../assets/img/toushin/image_1.svg'
import image2 from '../assets/img/toushin/image_2.svg'
import image3 from '../assets/img/toushin/image_3.svg'
import image4 from '../assets/img/toushin/image_4.svg'
import image5 from '../assets/img/toushin/image_5.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

export default function Toushin() {
  useHeadTitle('今こそ資産運用を考えよう', '投資信託とは')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  return (
    <React.Fragment>
      <Header />
      <main>
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">
              <span className="c-title__balloon">
                <span>仕組みとコツ</span>
              </span>
              <img src={titleToushin} alt="投資信託とは" />
            </h2>
            <p className="c-title__lead">
              これから投資信託をはじめたいという方はもちろん、
              <br />
              さらっとおさらいしたい方にも役立つ、投資信託の基礎知識です。
            </p>
          </div>
          <div className="l-container">
            <div className="u-pt27px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">投資信託の仕組みと特徴</span>
                </h3>
                <div className="p-toushin__box-body">
                  <section>
                    <h4 className="c-heading-1">投資信託の仕組み</h4>
                    <p className="p-toushin__lead--primary">
                      投資信託は、複数の投資家から資金を集めて、運用の専門家が債券や株式などに投資・運用する金融商品です。
                      <br />
                      投資信託の運用成果(運用によって生じた損益)は、投資家が保有している口数に応じて投資家にもたらされます。
                      <br />
                      投資信託は元本が保証されていないため、投資額を下回り損失が生じることもあります。
                    </p>
                    <p className="u-text--center u-mt23px">
                      <img src={image1} alt="投資信託の仕組み" />
                    </p>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt66px">投資信託の特徴</h4>
                    <p className="p-toushin__lead--primary">
                      投資信託は、以下のような特徴があり、様々なニーズに応えられる金融商品です。
                    </p>
                    <dl className="p-toushin__list-box">
                      <dt className="p-toushin__list-box__heading">
                        <span className="p-toushin__list-box__icon">1</span>
                        <p className="p-toushin__list-box__title">少額資金から投資が可能</p>
                      </dt>
                      <dd className="p-toushin__list-box__text">
                        通常、債券や株式などに投資するにはある程度まとまった資金が必要ですが、投資信託は1万円程度の資金から投資を始めることができます。
                      </dd>
                    </dl>
                    <dl className="p-toushin__list-box">
                      <dt className="p-toushin__list-box__heading">
                        <span className="p-toushin__list-box__icon">2</span>
                        <p className="p-toushin__list-box__title">多くの資産に分散投資が可能</p>
                      </dt>
                      <dd className="p-toushin__list-box__text">
                        投資信託は多くの投資家から資金を集めて、分散投資します。違う値動きをする投資先を組み合わせることで、投資のリスクを低くすることが期待できます。
                      </dd>
                    </dl>
                    <dl className="p-toushin__list-box u-mb20px">
                      <dt className="p-toushin__list-box__heading">
                        <span className="p-toushin__list-box__icon">3</span>
                        <p className="p-toushin__list-box__title">
                          資産運用の専門家が投資家に代わって運用
                        </p>
                      </dt>
                      <dd className="p-toushin__list-box__text">
                        投資対象の情報収集、分析、銘柄選択を専門家に任せたい、個人で直接投資することが難しい金融資産に投資したいといったニーズに対応できます。
                      </dd>
                    </dl>
                  </section>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">投資はリスクがあって怖い？</span>
                </h3>
                <div className="p-toushin__box-body">
                  <section>
                    <h4 className="c-heading-1">リスクとは</h4>
                    <p className="p-toushin__lead--primary">
                      {/* eslint-disable-next-line max-len */}
                      リスクとは、「危険＝損をする」という意味ではありません。投資では、「リターン（投資の収益／損失）の振れ幅」のことを指します。期待するリターンが大きければ大きいほど、値動きの幅も大きくなります。
                    </p>
                    <p className="u-text--center u-mt23px">
                      <img src={image2} alt="リスクのイメージ図" />
                    </p>
                    <p className="p-toushin__lead--primary u-mt36px">
                      一般的に期待するリターンが低い資産運用商品ほどリスクが小さく、リターンが高い資産運用商品ほどリスクが大きいことがわかります。
                    </p>
                    <p className="u-text--center u-mt23px">
                      <img src={image3} alt="資産運用商品のリスクとリターンの関係（イメージ図）" />
                    </p>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt69px">
                      リスクを減らす方法の一つに「分散投資」があります。
                    </h4>
                    <p className="p-toushin__lead--primary">
                      分散投資とは、「複数の異なる資産に投資をする」という意味です。値動きが異なるものを組み合わせることで、全体としてのリスクを抑えた投資が可能となります。
                    </p>
                    <p className="u-text--center u-mt23px">
                      <img src={image4} alt="分散投資の例" />
                    </p>
                    <p className="c-note u-mt10px">
                      ※上記はイメージ図であり、全てを説明しているものではありません。
                    </p>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt69px">
                      長期投資によって、リスクの低減が図れます。
                    </h4>
                    <p className="p-toushin__lead--primary">
                      国内外8つの資産に分散された資産を10年保有したリターンを見てみると、下グラフ期間内ではすべてのケースでプラスのリターンになりました。
                      資産運用は、「時間」を味方につけることも大切です。
                    </p>
                    <p className="u-text--center u-mt23px">
                      <img
                        src={image5}
                        alt="８つの資産に分散された資産※を10年間保有した場合の年率リターン"
                      />
                    </p>
                    <p className="c-note u-mt16px">
                      ※国内債券、国内株式、国内リート、外国債券、外国株式、外国リート、新興国債券、米国ハイ・イールド債券の8つの資産を1/8ずつの割合で、
                      各資産の月間リターンを基に毎月リバランス（相場変動などにより変化した投資比率を調整し1/8ずつの割合を維持）を行なったものとして、
                      野村アセットマネジメントが独自に計算したものです。
                      ただし、1984年12月末～1989年7月末の値は、国内リート、外国リート、新興国債券、米国ハイ・イールド債券を除く4資産を1/4ずつの割合で、
                      1989年8月末～1996年12月末の値は、国内リート、新興国債券、米国ハイ・イールド債券を除く5資産を1/5ずつの割合で、
                      1997年1月末～2002年12月末の値は、国内リート、新興国債券を除く6資産を1/6ずつの割合で、2003年1月末～2003年3月末の値は、
                      国内リートを除く7資産を1/7ずつの割合で計算しています。
                      <br />
                      例えば、2020年12月末の年率リターンは、2020年12月末までに10年間保有した場合の年率換算したリターンを示しています。
                      <br />
                      税金・手数料などは考慮しておりません。グラフは過去のデータであり、将来の投資成果を示唆あるいは保証するものではありません。
                    </p>
                    <p className="c-note u-mt6px">
                      （出所）ブルームバーグ等のデータを基に野村アセットマネジメント作成
                    </p>
                  </section>
                </div>
              </section>
            </div>
            <section>
              <p className="c-note u-text--bold u-mt63px">当資料で使用した指数等について</p>
              <p className="c-note">
                「国内債券」NOMURA-BPI総合、「外国債券」FTSE世界国債インデックス（除く日本、ヘッジなし・円ベース）、
                「国内株式」TOPIX（配当込み）（但し、1984年12月末～1989年1月末のリターンは東証一部の配当利回りの月次データを基に、当社独自に計算）、
                「外国株式」MSCI-KOKUSAI指数（円ベース・為替ヘッジなし）、「国内リート」東証REIT指数（配当込み)、
                「外国リート」S&amp;P先進国REIT指数（除く日本・配当込み・円ベース）、
                「新興国債券」JPモルガン・ガバメント・ボンド・インデックス-エマージング・マーケッツ・グローバル・ディバーシファイド（円換算ベース）、
                「米国ハイ・イールド債券」ICE BofA US Cash Pay High Yield Constrained
                Index（円換算ベース）
              </p>
              <p className="c-note u-text--bold u-mt16px">当資料で使用した指数の著作権等</p>
              {/* eslint-disable-next-line max-len */}
              <p className="c-note">
                {/* eslint-disable-next-line max-len */}
                「NOMURA-BPI総合」は、野村フィデューシャリー・リサーチ＆コンサルティング株式会社が作成している指数で、当該指数に関する一切の知的財産権とその他一切の権利は野村フィデューシャリー・リサーチ＆コンサルティング株式会社に帰属しております。
                また、野村フィデューシャリー・リサーチ＆コンサルティング株式会社は、当該インデックスの正確性、完全性、信頼性、有用性を保証するものではありません。
                <br />
                「FTSE世界国債インデックス（除く日本、ヘッジなし・円ベース）」は、 FTSE Fixed Income
                LLCにより運営されている債券インデックスです。 同指数はFTSE Fixed Income
                LLCの知的財産であり、 指数に関するすべての権利はFTSE Fixed Income
                LLCが有しています。
                <br />
                {/* eslint-disable-next-line max-len */}
                「東証株価指数（TOPIX）」、「東証REIT指数」の指数値及び「東証株価指数（TOPIX）」、「東証REIT指数」に係る標章又は商標は、株式会社ＪＰＸ総研又は株式会社ＪＰＸ総研の関連会社（以下「ＪＰＸ」という。）の知的財産であり、指数の算出、指数値の公表、利用など「東証株価指数（TOPIX）」、「東証REIT指数」に関するすべての権利・ノウハウ及び「東証株価指数（TOPIX）」、「東証REIT指数」に係る標章又は商標に関するすべての権利はＪＰＸが有します。ＪＰＸは、「東証株価指数（TOPIX）」、「東証REIT指数」の指数値の算出又は公表の誤謬、遅延又は中断に対し、責任を負いません。本商品は、ＪＰＸにより提供、保証又は販売されるものではなく、本商品の設定、販売及び販売促進活動に起因するいかなる損害に対してもＪＰＸは責任を負いません。
                <br />
                「MSCI-KOKUSAI指数」は、MSCIが開発した指数です。同指数に対する著作権、知的所有権、その他一切の権利はMSCIに帰属します。
                またMSCIは同指数の内容を変更する権利および公表を停止する権利を有しています。
                <br />
                「S&amp;P先進国REIT指数」はスタンダード＆プアーズ ファイナンシャル サービシーズ エル
                エル シーの所有する登録商標です。
                <br />
                「日経平均株価（日経225）」に関する著作権、知的所有権、その他一切の権利は日本経済新聞社に帰属します。
                <br />
                日本経済新聞社は、日経平均株価の内容を変える権利および公表を停止する権利を有しています。
                <br />
                「Dow Jones&reg;」および「The Dow&reg;」はDow Jones Trademark Holdings LLC（「Dow
                Jones」）の登録商標です。
                <br />
                「ニューヨークダウ平均株価」に関する著作権、知的所有権、その他一切の権利はS&amp;P
                ダウ・ジョーンズ・インデックス社（S&amp;P Dow Jones Indices, LLC）に帰属します。
                <br />
                「ICE BofA US Cash Pay High Yield Constrained Index SM/&reg;」は、ICE Data Indices,
                LLC またはその関連会社の登録商標です。
                <br />
                「JPモルガン・ガバメント・ボンド・インデックス-エマージング・マーケッツ・グローバル・ディバーシファイド
                （JP Morgan Government Bond Index-Emerging Markets（GBI-EM）Global
                Diversified）」は、 J.P.Morgan Securities LLCが公表している、
                現地通貨建てのエマージング・マーケット債を対象としたインデックスであり、その著作権および知的財産権は同社に帰属します。
              </p>
            </section>
          </div>
        </section>

        <div className="u-bg--white u-mt60px">
          <div className="c-button-group">
            <Link to={useDealerCodeUrl('/')} className="c-button--primary c-button-arrow--back">
              <span className="c-button__text--xs">TOPページへ戻る</span>
            </Link>
            <Link
              to={useDealerCodeUrl('/tsumitate')}
              className="c-button--primary c-button-arrow--next"
            >
              <span className="c-button__text--xs u-mr10px">つみたて投資とはへ進む</span>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
